(() => {
  const roots = '.rte,.nyvolt-rich-description,.nv-dt__description,.nv-product-categories__body,.nv-product-tabs__panel,.nv-story__copy,.nv-mobility__guide-grid';
  const ignored = 'strong,b,em,i,a,button,nav,summary,table,h1,h2,h3,h4,h5,h6,script,style,form,textarea,code,pre,svg,[data-nv-copy-emphasis]';
  const seen = new WeakSet();
  const strongPattern = /\d[\d\s.,]*(?:km\/h|kWh|Wh|km|Ah|kW|W|V)(?![\p{L}\p{N}])|double motorisation|freins hydrauliques|suspensions réglables|batterie amovible|hydraulic brakes|dual motors|removable battery|hamulce hydrauliczne|wyjmowany akumulator/giu;
  const italicPattern = /annoncée à environ|chargeur rapide inclus|autonomie réelle|sur terrain privé(?: autorisé)?|selon votre usage|selon la version|au quotidien|pour vos déplacements|à votre rythme|selon la configuration|on private land|depending on your use|claimed range|for everyday journeys|na terenie prywatnym|na co dzień/giu;
  const enhance = scope => {
    const containers = [...(scope.matches?.(roots) ? [scope] : []), ...scope.querySelectorAll(roots)];
    containers.forEach(container => {
      const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
          const parent = node.parentElement;
          if (!parent || seen.has(node) || !node.nodeValue.trim() || parent.closest(ignored) || !parent.closest('p,li,dd')) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      });
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(node => {
        if (seen.has(node) || node.parentElement?.closest(ignored)) return;
        seen.add(node);
        const original = node.nodeValue;
        const ranges = [];
        for (const match of original.matchAll(strongPattern)) {
          ranges.push({start:match.index,end:match.index + match[0].length,tag:'strong'});
          if (ranges.length === 2) break;
        }
        const italics = [...original.matchAll(italicPattern)].find(match => !ranges.some(range => match.index < range.end && match.index + match[0].length > range.start));
        if (italics) ranges.push({start:italics.index,end:italics.index + italics[0].length,tag:'em'});
        if (!ranges.length) return;
        ranges.sort((a,b) => a.start - b.start);
        const fragment = document.createDocumentFragment();
        let cursor = 0;
        ranges.forEach(range => {
          fragment.append(document.createTextNode(original.slice(cursor,range.start)));
          const emphasis = document.createElement(range.tag);
          emphasis.dataset.nvCopyEmphasis = '';
          emphasis.textContent = original.slice(range.start,range.end);
          fragment.append(emphasis);
          cursor = range.end;
        });
        fragment.append(document.createTextNode(original.slice(cursor)));
        node.replaceWith(fragment);
      });
    });
  };
  enhance(document);
  document.addEventListener('shopify:section:load',event => enhance(event.target));
})();
